// (c) chaehongee. Confidential and proprietary.

const CHECKOUT_RETURN_TO_KEY = 'knoll.checkout.returnTo.v1'

export function setCheckoutReturnTo(url: string = getCurrentAppUrl()): void {
    try {
        window.localStorage.setItem(CHECKOUT_RETURN_TO_KEY, url)
    } catch {
        // Best-effort; don't block checkout redirects if storage is unavailable.
    }
}

export function getCheckoutReturnTo(): string | null {
    try {
        const raw = window.localStorage.getItem(CHECKOUT_RETURN_TO_KEY)
        if (!raw) return null
        return sanitizeReturnTo(raw)
    } catch {
        return null
    }
}

export function clearCheckoutReturnTo(): void {
    try {
        window.localStorage.removeItem(CHECKOUT_RETURN_TO_KEY)
    } catch {
        // no-op
    }
}

function getCurrentAppUrl(): string {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`
}

function sanitizeReturnTo(raw: string): string | null {
    const trimmed = raw.trim()

    // Only allow same-origin relative navigation.
    if (!trimmed.startsWith('/')) return null
    if (trimmed.startsWith('//')) return null
    if (trimmed.includes('://')) return null

    // Avoid redirect loops back into the callback.
    if (trimmed.startsWith('/checkout/stripe')) return null
    if (trimmed.startsWith('/checkout/subscription')) return null

    return trimmed
}

